<mtna-i18n-editor-focus-indicator
  *ngIf="(languages | mtnaOptionsToLanguageIds).length > 1"
  [active]="_focused"
  [showInactive]="alwaysShowOtherLanguages"
></mtna-i18n-editor-focus-indicator>

<div
  cdkMonitorSubtreeFocus
  class="rds-c-i18n-rich-text-editor--container"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  (cdkFocusChange)="_focused = $event"
>
  <rds-c-rich-text-editor
    cdkMonitorSubtreeFocus
    hideEditorControls
    [class.active]="_primaryFocus"
    [languageId]="defaultLanguageId"
    [valueObservable]="_internalValueSubjects[defaultLanguageId]"
    [readonly]="readonly"
    (cdkFocusChange)="_handlePrimaryFocus($event)"
    (valueChange)="handleValueChange(defaultLanguageId, $event)"
  ></rds-c-rich-text-editor>

  <ng-container *ngIf="(languages | mtnaOptionsToLanguageIds).length > 1 && (_focused || alwaysShowOtherLanguages)">
    <ng-container *ngIf="defaultLanguageId | mtnaOptionsToOtherLanguageIds: languages as secondary" [ngPlural]="secondary.length">
      <ng-template ngPluralCase="=1">
        <div
          cdkMonitorSubtreeFocus
          class="rds-c-i18n-rich-text-editor--secondary"
          [class.active]="_secondaryFocus"
          (cdkFocusChange)="_handleSecondaryFocus($event)"
        >
          <ng-container [ngTemplateOutlet]="editor" [ngTemplateOutletContext]="{ $implicit: secondary[0] }"></ng-container>
        </div>
      </ng-template>

      <ng-template ngPluralCase="other">
        <mtna-tab-wrapper
          *ngIf="secondary.length <= maxTabs; else select"
          cdkMonitorSubtreeFocus
          appearance="outline"
          fxFlex="grow"
          [active]="_secondaryFocus"
          [values]="secondary"
          (cdkFocusChange)="_handleSecondaryFocus($event)"
        >
          <ng-template #tabWrapperContent let-lang>
            <ng-container [ngTemplateOutlet]="editor" [ngTemplateOutletContext]="{ $implicit: lang }"></ng-container>
          </ng-template>
        </mtna-tab-wrapper>

        <ng-template #select>
          <mtna-select-wrapper
            cdkMonitorSubtreeFocus
            appearance="outline"
            ariaLabel="Languages"
            i18n-ariaLabel
            fxFlex="grow"
            [active]="_secondaryFocus"
            [values]="secondary"
            (cdkFocusChange)="_handleSecondaryFocus($event)"
          >
            <ng-template #selectWrapperContent let-lang>
              <ng-container [ngTemplateOutlet]="editor" [ngTemplateOutletContext]="{ $implicit: lang }"></ng-container>
            </ng-template>
          </mtna-select-wrapper>
        </ng-template>
      </ng-template>
    </ng-container>
  </ng-container>

  <mtna-inline-editor-controls
    *ngIf="!hideEditorControls"
    [applying]="applying"
    [hidden]="!_internalValueChanges || readonly"
    (action)="handleEditorControlAction($event)"
  ></mtna-inline-editor-controls>
</div>

<ng-template #editor let-lang>
  <rds-c-rich-text-editor
    hideEditorControls
    [class.active]="_secondaryFocus"
    [languageId]="lang"
    [valueObservable]="_internalValueSubjects[lang]"
    [readonly]="readonly"
    (valueChange)="handleValueChange(lang, $event)"
  >
  </rds-c-rich-text-editor>
</ng-template>
